module.exports = __webpack_public_path__ + "static/img/yixichatshow.c780667a.png";